// This file is auto-generated by db/scripts/generate-prisma-enums.mjs.
// Do not edit manually.
// Client-safe enum mirror: use in webapp client code to avoid Prisma runtime imports.

export const Sex = {
  M: 'M',
  F: 'F',
  Other: 'Other',
} as const;

// prettier-ignore
export type Sex = (typeof Sex)[keyof typeof Sex];

export const WorkoutStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
} as const;

// prettier-ignore
export type WorkoutStatus = (typeof WorkoutStatus)[keyof typeof WorkoutStatus];

export const ZoneType = {
  HEART_RATE: 'HEART_RATE',
  POWER: 'POWER',
} as const;

// prettier-ignore
export type ZoneType = (typeof ZoneType)[keyof typeof ZoneType];

export const ZoneCalcMethod = {
  Karvonen: 'Karvonen',
  Zoladz: 'Zoladz',
  FoxHaskell: 'FoxHaskell',
} as const;

// prettier-ignore
export type ZoneCalcMethod = (typeof ZoneCalcMethod)[keyof typeof ZoneCalcMethod];

export const PlanGoal = {
  Marathon: 'Marathon',
  HalfMarathon: 'HalfMarathon',
  Triathlon: 'Triathlon',
  Swimming: 'Swimming',
  FiveKRun: 'FiveKRun',
  TenKRun: 'TenKRun',
  HappyRun: 'HappyRun',
} as const;

// prettier-ignore
export type PlanGoal = (typeof PlanGoal)[keyof typeof PlanGoal];

export const RaceDistance = {
  HalfIronman: 'HalfIronman',
  FullIronman: 'FullIronman',
} as const;

// prettier-ignore
export type RaceDistance = (typeof RaceDistance)[keyof typeof RaceDistance];

export const Status = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;

// prettier-ignore
export type Status = (typeof Status)[keyof typeof Status];

export const CreatedSource = {
  PLAN_INSTANCE: 'PLAN_INSTANCE',
  USER_APP: 'USER_APP',
} as const;

// prettier-ignore
export type CreatedSource = (typeof CreatedSource)[keyof typeof CreatedSource];

export const AdjustmentScope = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
} as const;

// prettier-ignore
export type AdjustmentScope = (typeof AdjustmentScope)[keyof typeof AdjustmentScope];

export const AdjustmentSource = {
  CRON: 'CRON',
  USER: 'USER',
} as const;

// prettier-ignore
export type AdjustmentSource = (typeof AdjustmentSource)[keyof typeof AdjustmentSource];

export const TimePeriod = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  SEASONAL: 'SEASONAL',
} as const;

// prettier-ignore
export type TimePeriod = (typeof TimePeriod)[keyof typeof TimePeriod];

export const EventStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
} as const;

// prettier-ignore
export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus];

export const UnitSystem = {
  scientific: 'scientific',
  imperial: 'imperial',
} as const;

// prettier-ignore
export type UnitSystem = (typeof UnitSystem)[keyof typeof UnitSystem];
